import React, { useState } from 'react';
import {
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  Box,
  Switch,
  Container,
  FormControlLabel,
} from '@mui/material';

import {
  Business,
  Phone,
} from '@mui/icons-material';

import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../Auth/AuthProvider';
import { can } from '../../Conections/LogConections';
import { SetTermometerCreate } from '../../Conections/GreenhouseConection';

const TermometerCreate = () => {

  const goTo = useNavigate();
  const { getToken, getCompany } = useAuth();
  const { greenmodulesid } = useParams();

  const [greenmoduleinuse, setGreenmoduleinuse] = useState(false);
  const [greenmodulemac, setGreenmodulemac] = useState("");
  const [greenmoduleserial, setGreenmoduleserial] = useState("");

  const [errors, setErrors] = useState({});

  React.useEffect(() => {
    reloaduser();
  }, []);

  async function reloaduser() {
    if (getToken()) {
      const permisionCan = await can(getToken(), getCompany(), "/greenhouse/creategreenhouse");
      if (permisionCan === 0) {
        goTo("/dashboard");
      }
    }
    else {
      goTo(`/login`);
    }
  }

  const handleChangeInUse = (e) => {
    const { name, value } = e.target;
    setGreenmoduleinuse(e.target.checked);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setGreenmodulemac(value);
  };

  const handleChangeSerial = (e) => {
    const { name, value } = e.target;
    setGreenmoduleserial(value);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!greenmodulemac.trim()) {
      newErrors.mac = 'La MAC es requerido';
    }
    if (!greenmoduleserial.trim()) {
      newErrors.serial = 'La MAC es requerido';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      const datos = await SetTermometerCreate(
        getToken(),
        getCompany(),
        greenmodulesid,
        greenmoduleinuse ? 1 : 0,
        greenmodulemac.trim(),
        greenmoduleserial.trim(),
      );
      console.log(datos);
      /* goTo(`/greenhouse/showgreenhouse/${datos}`);*/
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" component="h1" align="center" gutterBottom>
          Crear Nuevo Termometro
        </Typography>
        <Card>
          <CardContent>
            <form onSubmit={handleSubmit}>
              <FormControlLabel
                control={
                  <Switch
                    checked={greenmoduleinuse}
                    onChange={handleChangeInUse}
                    name="Inuse"
                  />
                }
                label="En uso"
                sx={{ mt: 2 }}
              />

              <TextField
                fullWidth
                label="MAC"
                name="mac"
                value={greenmodulemac}
                onChange={handleChange}
                InputProps={{
                  startAdornment: <Business sx={{ mr: 1, color: 'action.active' }} />,
                }}
                margin="normal"
                error={!!errors.nombre}
                helperText={errors.nombre}
              />

              <TextField
                fullWidth
                label="Serial"
                name="serial"
                value={greenmoduleserial}
                onChange={handleChangeSerial}
                InputProps={{
                  startAdornment: <Business sx={{ mr: 1, color: 'action.active' }} />,
                }}
                margin="normal"
                error={!!errors.nombre}
                helperText={errors.nombre}
              />

              <Box sx={{ mt: 2 }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                >
                  Crear Invernadero
                </Button>
              </Box>
            </form>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default TermometerCreate;